// src/components/iaDashboard/cards/AvgSessionTimeCard.jsx
import React from "react";

export default function AvgSessionTimeCard({ value }) {
  const minutes = value ?? 0;

  return (
    <div className="ia-card ia-card-time">
      <div className="ia-card-header">
        <span className="ia-card-label">Duração média da sessão</span>
      </div>
      <div className="ia-card-value">
        {minutes.toFixed ? minutes.toFixed(1) : minutes} min
      </div>
      <p className="ia-card-sub">
        Tempo médio entre o início e o encerramento do atendimento.
      </p>
    </div>
  );
}
